import { Box } from '@mui/material';
import { Outlet } from 'react-router';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const SIDEBAR_WIDTH = 228;

export const AppShell = () => (
  <Box sx={{ display: 'flex', height: '100vh' }}>
    <Sidebar width={SIDEBAR_WIDTH} />
    <Box component="main" sx={{ display: 'flex', flex: 1, flexDirection: 'column', minHeight: 0, minWidth: 0 }}>
      <Topbar />
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          minHeight: 0,
          overflow: 'auto',
          pb: 3,
          pt: 3,
          px: { md: 3.5, xs: 2 },
        }}
      >
        {/* minHeight: 0 lets `fill` panels size to the visible area instead of growing with their content. */}
        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', maxWidth: 1800, minHeight: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  </Box>
);
